import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00278 = new TileLayer({
  title: 'Máscara 20030915',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030915l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00278.setVisible(false);

const layer00277 = new TileLayer({
  title: 'Máscara 20031009',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20031009l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00277.setVisible(false);

const layer00276 = new TileLayer({
  title: 'Máscara 20031212',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20031212l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00276.setVisible(false);

const layer00275 = new TileLayer({
  title: 'Máscara 20040121',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040121l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00275.setVisible(false);

const layer00274 = new TileLayer({
  title: 'Máscara 20040317',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040317l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00274.setVisible(false);

const layer00273 = new TileLayer({
  title: 'Máscara 20040325',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040325l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00273.setVisible(false);

const layer00272 = new TileLayer({
  title: 'Máscara 20040426',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040426l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00272.setVisible(false);

const layer00271 = new TileLayer({
  title: 'Máscara 20040613',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040613l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00271.setVisible(false);

const layer00270 = new TileLayer({
  title: 'Máscara 20040707',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040707l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00270.setVisible(false);

const layer00269 = new TileLayer({
  title: 'Máscara 20040715',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040715l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00269.setVisible(false);
  
const layer00268 = new TileLayer({
  title: 'Máscara 20040731',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040731l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00268.setVisible(false);
  
const layer00267 = new TileLayer({
  title: 'Máscara 20040816',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20040816l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00267.setVisible(false);

export const grupoCapa01_18 = new LayerGroup({
  title: 'Ciclo Hidrológico 2003-2004',
  fold: 'close',
  layers: [layer00267, layer00268, layer00269, layer00270, layer00271, layer00272, layer00273, layer00274, layer00275, layer00276, layer00277, layer00278]
});